import { createRouter, createWebHistory } from 'vue-router'
import Voucher from '../views/Voucher.vue'
import Campaign from '../views/Campaign.vue'

const routes = [
    {
        path: '',
        name: 'home',
        component: Voucher,
        meta: {
            freeAccess: true,
        }
    },
    {
        path: '/campaign/:qrcode',
        name: 'campaign',
        component: Campaign,
        meta: {
            freeAccess: true,
        }
    },
]
const router = createRouter({
    history: createWebHistory(),
    routes,
})
router

export default router